module.exports = __webpack_public_path__ + "assets/images/key/key_lon_syd_2019.svg?v=8cb073d9";